import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaHome } from 'react-icons/fa';

const NotFoundPage = () => {
  const { t } = useTranslation();
  return (
    <div className=" min-h-screen bg-[#ffffff] flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <div className="w-24 h-24 bg-gradient-to-br from-primary-500 to-primary-600 rounded-3xl flex items-center justify-center mx-auto mb-6">
            <span className="text-white font-bold text-3xl">404</span>
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">{t('notFound.title')}</h1>
          <p className="text-lg text-gray-600 mb-8">
            {t('notFound.description')}
          </p>
        </div>
        
        <div className="space-y-4">
          <Link
            to="/studio/dashboard"
            className="btn-primary inline-flex items-center"
          >
            <FaHome className="mr-2" />
            {t('notFound.goDashboard')}
          </Link>
          
          <button
            onClick={() => window.history.back()}
            className="btn-secondary inline-flex items-center"
          >
            <span className="mr-2">←</span>
            {t('notFound.goBack')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
